import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-x-button',
  templateUrl: './x-button.component.html',
  styleUrls: ['./x-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XButtonComponent {
  // constructor() {}
}
